import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router';
import DeleteIcon from '@material-ui/icons/Delete';

import VariableSelector from '../../components/variableSelector';
import ToggleButton from '../../components/toggleButton';
import Typography from '@material-ui/core/Typography';
import DatePicker from '@material-ui/lab/DatePicker';
import {
  Paper,
  Box,
  Grid,
  Container,
  FormControlLabel,
  Button,
  TextField,
  Checkbox,
  Autocomplete,
  createFilterOptions,
} from '@material-ui/core';

import { useAPI } from '../../utils/api';
import { useDialog } from '../../utils/dialog';
import { MODE } from '../../utils/mode';

const FeeSettingDetailPage = () => {
  const { activityID } = useParams();
  const [createStartDateValue, setCreateStartDateValue] = useState(null);
  const [createEndDateValue, setCreateEndDateValue] = useState(null);
  const [feeData, setFeeData] = useState(null);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [arrayAgree, setArrayAgree] = useState([]);
  const [memberMenu, setMemberMenu] = useState([]);
  const [deleteMember, setDeleteMember] = useState([]);
  const [isUnmounted, setIsUnmounted] = useState(false);
  const [selectedMember, setSelectedMember] = useState({ text: '', value: '' });
  const [memberInputValue, setMemberInputValue] = useState('');
  const [shouldPageUpdated, setShouldPageUpdated] = useState(false);
  const [mode, setMode] = useState('');
  const checkAll = useRef(null);

  const api = useAPI();
  const history = useHistory();

  const dialog = useDialog();

  activityID;

  useEffect(() => {
    setShouldPageUpdated(false);
  }, [shouldPageUpdated]);

  const doDelete = () => {
    if (deleteMember.length > 0) {
      const arrayMember = [];
      for (const element of arrayAgree) {
        for (const de of deleteMember) {
          if (Number.parseInt(element.value) !== Number.parseInt(de.value)) {
            arrayMember.push(element);
          }
        }
      }
      setArrayAgree(arrayMember);
      setShouldPageUpdated(true);
    }
  };

  const selectDeleteItem = (isChecked, data) => {
    if (isChecked) {
      const arrayMember = [];
      for (const element of arrayAgree) {
        if (Number.parseInt(element.value) === Number.parseInt(data.value)) {
          arrayMember.push(element);
        }
      }
      setDeleteMember(arrayMember);
    } else {
      const arrayMember = [];
      for (const element of deleteMember) {
        if (Number.parseInt(element.value) !== Number.parseInt(data.value)) {
          arrayMember.push(element);
        }
      }
      setDeleteMember(arrayMember);
    }
  };

  const addMember2List = () => {
    if (checkAll.current.checked) {
      const all = {
        text: '全部',
        value: '-1',
      };

      const arrayMember = [];
      arrayMember.push(all);

      setArrayAgree(arrayMember);
    } else {
      if (selectedMember.value !== '') {
        const arrayMember = [];
        for (const element of arrayAgree) {
          if (
            Number.parseInt(element.value) ===
            Number.parseInt(selectedMember.value)
          ) {
            dialog.openAlert({ message: '已有相同的會員資料。' });
          } else {
            arrayMember.push(element);
          }
        }
        arrayMember.push(selectedMember);

        setArrayAgree(arrayMember);
      }
    }
  };

  const handleAll = (event) => {
    api;
    if (event.target.checked) {
      setIsCheckAll(event.target.checked);
      const all = {
        text: '全部',
        value: '-1',
      };
      const arrayMember = [];
      arrayMember.push(all);

      setArrayAgree(arrayMember);
      setShouldPageUpdated(true);
    } else {
      setIsCheckAll(event.target.checked);
      const arrayMember = [];
      for (const element of memberMenu) {
        for (const fee of feeData.memberIdList) {
          if (Number.parseInt(element.value) === fee) {
            arrayMember.push(element);
          }
        }
      }
      setArrayAgree(arrayMember);
    }
  };

  useEffect(() => {
    if (activityID === undefined) {
      setMode(MODE.NEW);
      setFeeData({});
      api
        .getFeeMemberMenu()
        .then((menu) => {
          if (!isUnmounted) {
            setMemberMenu(menu);
          }
        })
        .catch(() => {});
    } else {
      setMode(MODE.EDIT);
      api
        .getFeeDetail(activityID)
        .then((result) => {
          if (!isUnmounted) {
            setFeeData(result);
            setCreateStartDateValue(result.startDate);
            setCreateEndDateValue(result.endDate);

            api
              .getFeeMemberMenu()
              .then((menu) => {
                if (!isUnmounted) {
                  setMemberMenu(menu);

                  if (result.settingAll) {
                    const all = {
                      text: '全部',
                      value: '-1',
                    };
                    const arrayMember = [];
                    arrayMember.push(all);
                    setIsCheckAll(true);
                    setArrayAgree(arrayMember);
                  } else {
                    const arrayMember = [];
                    for (const element of menu) {
                      for (const fee of result.memberIdList) {
                        if (Number.parseInt(element.value) === fee) {
                          arrayMember.push(element);
                        }
                      }
                    }
                    setArrayAgree(arrayMember);
                  }
                }
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }

    return () => {
      setIsUnmounted(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterOptions = createFilterOptions({
    limit: 20,
  });

  const doSave = (event) => {
    event.preventDefault();
    api;
    const form = event.target;
    const formData = new FormData(form);

    if (formData.get('createTime') == null || formData.get('endTime') == null) {
      dialog.openAlert({ message: '設定日期為必填項目' });
      return;
    }
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const day = new Date().getDate(); //日

    // console.log('toddddday', `${year}/${month}/${day}`);
    const today = new Date(`${year}/${month}/${day}`).getTime();
    const start = new Date(formData.get('createTime')).getTime();
    const end = new Date(formData.get('endTime')).getTime();

    if (start > end) {
      dialog.openAlert({
        message: '起始日不能大於結束日',
      });
      return;
    }

    if (start < today) {
      dialog.openAlert({
        message: '起始日不能小於今日',
      });
      return;
    }

    const difference = Math.abs(end - start);
    const days = difference / (1000 * 3600 * 24);
    if (days > 365) {
      dialog.openAlert({
        message: '活動起日到迄日的區間不可大於365天',
      });
      return;
    }

    if (
      formData.get('upStandardFee') == null ||
      formData.get('notUpStandardFee') == null
    ) {
      dialog.openAlert({ message: '請確認您的資料是否填寫完整' });
      return;
    }

    if (!feeData.isLocked && formData.get('activityName') == null) {
      dialog.openAlert({ message: '請確認您的資料是否填寫完整' });
      return;
    }

    const arrayMember = [];
    for (const element of arrayAgree) {
      const member_id = Number.parseInt(element.value);
      arrayMember.push(member_id);
    }
    const data =
      mode === MODE.NEW
        ? {
            setting_all: isCheckAll,
            member_id_list: isCheckAll ? [] : arrayMember,
            activity_name: formData.get('activityName'),
            up_standard_fee: Number.parseInt(formData.get('upStandardFee')),
            not_up_standard_fee: Number.parseInt(
              formData.get('notUpStandardFee')
            ),
            start_date: formData.get('createTime'),
            end_date: formData.get('endTime'),
          }
        : {
            activity_id: Number.parseInt(activityID),
            setting_all: isCheckAll,
            member_id_list: isCheckAll ? [] : arrayMember,
            activity_name: feeData.isLocked
              ? feeData.activityName
              : formData.get('activityName'),
            up_standard_fee: Number.parseInt(formData.get('upStandardFee')),
            not_up_standard_fee: Number.parseInt(
              formData.get('notUpStandardFee')
            ),
            start_date: formData.get('createTime'),
            end_date: formData.get('endTime'),
          };

    if (mode === MODE.NEW) {
      api
        .saveFee(data)
        .then(() => {
          if (!isUnmounted) {
            // dialog.openAlert({
            //   message: '新增成功',
            // });
            const yes = confirm('新增成功');
            if (yes) {
              history.goBack();
            }
            // history.goBack();
          }
        })
        .catch(() => {});
    } else {
      api
        .updateFee(data)
        .then(() => {
          if (!isUnmounted) {
            // dialog.openAlert({
            //   message: '修改成功',
            // });
            const yes = confirm('修改成功');
            if (yes) {
              history.goBack();
            }
          }
        })
        .catch(() => {});
    }
  };

  return (
    <>
      <Box component="form" noValidate onSubmit={doSave}>
        {memberMenu && feeData ? (
          <Paper
            elevation={4}
            sx={{
              paddingTop: { xs: 1, md: 2 },
              paddingBottom: { xs: 2, md: 4 },
              marginBottom: 4,
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Container>
              <Grid item xs={12} sm={6}>
                {!feeData.isLocked && !isCheckAll ? (
                  <Autocomplete
                    options={memberMenu}
                    getOptionLabel={(option) => option.text || ''}
                    renderOption={(properties, option) => (
                      <li {...properties}>
                        <Typography noWrap>{option.text}</Typography>
                      </li>
                    )}
                    renderInput={(parameters) => (
                      <TextField
                        {...parameters}
                        label="會員編號"
                        name="selectedMember"
                        fullWidth
                      />
                    )}
                    filterOptions={filterOptions}
                    value={selectedMember}
                    onChange={(event, newValue) => {
                      setSelectedMember(newValue);
                    }}
                    inputValue={memberInputValue}
                    onInputChange={(event, newInputValue) => {
                      setMemberInputValue(newInputValue);
                    }}
                  />
                ) : (
                  <VariableSelector
                    mode={'view'}
                    name="memberType"
                    label="會員編號"
                    text={'全部'}
                    defaultValue={'全部'}
                    options={memberMenu}
                    onChange={() => {}}
                  />
                )}
              </Grid>
              {feeData.isLocked ? undefined : (
                <Grid container spacing={3}>
                  <Grid item xs={5} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked={feeData.settingAll}
                          inputRef={checkAll}
                          // checked={data.settingAll}
                          onChange={handleAll}
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label="設定全部"
                    />
                  </Grid>
                  <Grid item xs={3} sm={4}></Grid>
                  <Grid item xs={4} sm={4}>
                    {!isCheckAll ? (
                      <Button
                        fullWidth
                        variant="contained"
                        color="success"
                        sx={{ color: 'white' }}
                        onClick={() => {
                          addMember2List();
                        }}
                      >
                        新增活動
                      </Button>
                    ) : undefined}
                  </Grid>
                </Grid>
              )}
            </Container>
          </Paper>
        ) : undefined}
        {feeData && !feeData.isLocked ? (
          <Paper
            elevation={4}
            sx={{
              paddingTop: { xs: 1, md: 2 },
              paddingBottom: { xs: 2, md: 4 },
              marginBottom: 4,
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Container>
              <Typography variant="body2" marginTop={2} marginBottom={2}>
                符合會員
              </Typography>
              {!shouldPageUpdated ? (
                <Grid container spacing={3}>
                  {arrayAgree
                    ? arrayAgree.map((data, index) => (
                        <Grid key={`${index}`} item xs={4} sm={4}>
                          <ToggleButton
                            id={`item-${index}`}
                            value="display"
                            type="button"
                            fullWidth
                            variant="contained"
                            checkedText={data.text}
                            uncheckedText={data.text}
                            checkedColor="error"
                            uncheckedColor="primary"
                            onClickToggle={(isChecked) => {
                              selectDeleteItem(isChecked, data);
                            }}
                            initChecked={false}
                            // locked={mode !== MODE.EDIT}
                          />
                        </Grid>
                      ))
                    : undefined}
                </Grid>
              ) : undefined}
              <div style={{ paddingTop: 20 }}>
                <Grid container spacing={3}>
                  <Grid item xs={4} sm={4}></Grid>
                  <Grid item xs={4} sm={4}></Grid>
                  <Grid item xs={4} sm={4}>
                    {!isCheckAll ? (
                      <Button
                        fullWidth
                        startIcon={<DeleteIcon />}
                        color="error"
                        variant="contained"
                        onClick={() => {
                          doDelete();
                        }}
                      >
                        刪除
                      </Button>
                    ) : undefined}
                  </Grid>
                </Grid>
              </div>
            </Container>
          </Paper>
        ) : undefined}

        {feeData ? (
          <Paper
            elevation={4}
            sx={{
              paddingTop: { xs: 1, md: 2 },
              paddingBottom: { xs: 2, md: 4 },
              marginBottom: 4,
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Container>
              <Grid container spacing={3}>
                <Grid item xs={9} sm={9}>
                  <TextField
                    name="activityName"
                    label="活動名稱"
                    fullWidth
                    required
                    variant={feeData.isLocked ? 'filled' : 'standard'}
                    disabled={feeData.isLocked}
                    // defaultValue={'111111'}
                    defaultValue={feeData ? feeData.activityName : ''}
                  />
                </Grid>
              </Grid>
              <div style={{ paddingTop: 10 }}>
                <Grid container spacing={3}>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      name="upStandardFee"
                      label="設定達標金額"
                      variant={'standard'}
                      defaultValue={feeData ? feeData.upStandardFee : 0}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      name="notUpStandardFee"
                      label="未達標月結手續費"
                      variant={'standard'}
                      defaultValue={feeData ? feeData.notUpStandardFee : 0}
                    />
                  </Grid>
                </Grid>
              </div>
              <div style={{ paddingTop: 10 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6}>
                    <DatePicker
                      label="活動起始日"
                      value={createStartDateValue}
                      onChange={(newValue) => {
                        setCreateStartDateValue(newValue);
                      }}
                      mask="____-__-__"
                      inputFormat={'yyyy/MM/dd'}
                      clearable={true}
                      clearText="清除"
                      cancelText="取消"
                      okText="確定"
                      renderInput={(parameters) => (
                        <TextField
                          id="createTime"
                          name="createTime"
                          label="活動起始日"
                          fullWidth
                          variant="standard"
                          size="small"
                          autoComplete="none"
                          {...parameters}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <DatePicker
                      label="活動結束日"
                      value={createEndDateValue}
                      onChange={(newValue) => {
                        setCreateEndDateValue(newValue);
                      }}
                      mask="____-__-__"
                      inputFormat={'yyyy/MM/dd'}
                      clearable={true}
                      clearText="清除"
                      cancelText="取消"
                      okText="確定"
                      renderInput={(parameters) => (
                        <TextField
                          id="endTime"
                          name="endTime"
                          label="活動結束日"
                          fullWidth
                          variant="standard"
                          size="small"
                          autoComplete="none"
                          {...parameters}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </div>
              <Grid
                container
                spacing={3}
                sx={{ margin: 'auto', width: '100%', justifyContent: 'center' }}
              >
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    儲存
                  </Button>
                </Grid>
                <Grid item xs={10} sm={4} sx={{ maxWidth: '200px' }}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="error"
                    // onClick={() => clearCondition(event)}
                  >
                    取消
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </Paper>
        ) : undefined}
      </Box>
    </>
  );
};

export default FeeSettingDetailPage;
